export default function RogersMistakesSection() {
  return (
    <section id="mistakes" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Common Mistakes</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">Don't Let These Errors Delay Your Trip</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[
            { title: "Wrong Photo Size", desc: "Must be 2x2 inches with white background. We provide exact specifications to avoid rejection." },
            { title: "Expired Name Documents", desc: "Name changes require certified marriage certificate or court order. Photocopies not accepted." },
            { title: "Incomplete DS-11 Forms", desc: "Missing signatures are the #1 delay. We review every form before submission." },
            { title: "Wrong Payment Amount", desc: "Government fees change. We confirm current amounts so your payment is accurate." },
            { title: "Missing Parental Consent", desc: "Children under 16 need both parents or notarized DS-3053. We help with this requirement." },
            { title: "Waiting Too Long", desc: "Standard processing takes 8–11 weeks. Start your application the moment you book travel." },
          ].map((m, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-red-50 mb-4"><i className="ri-close-circle-line text-red-500 text-xl"></i></div>
              <h3 className="font-bold text-[#1A365D] text-lg mb-2">{m.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{m.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}